import React from "react";
import { useParams } from "react-router-dom";
import VehicleTracker from "../vehicle/VehicleTracker";

export default function SchoolVehicleMonitor() {
  const { vehicleId } = useParams();

  return <VehicleTracker vehicleId={vehicleId} isSchoolMonitor={true} />;
}